import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { ComponentRoute } from '../ComponentRoute';
import { OptionalRedirect } from '../OptionalRedirect';
/**
 * Converts the `routes` array into React components with all the bells and whistles required.
 * @param routes the routes array that will be converted to components
 * @param parentRoute only used internally to make the recursion work
 * @param path only used internally to make the recursion work
 */
export const RoutingComponents = ({ routes, parentRoute, path = '', }) => {
    const location = useLocation();
    if (routes.length === 0) {
        return null;
    }
    let pathname = location.pathname;
    if ((pathname === null || pathname === void 0 ? void 0 : pathname.indexOf('!')) > 0) {
        location.hash = pathname.substring(pathname.indexOf('!') + 1);
        pathname = pathname.substring(0, pathname.indexOf('!'));
    }
    if (pathname === null || pathname === void 0 ? void 0 : pathname.endsWith('/')) {
        pathname = pathname.substring(0, pathname.length - 1);
    }
    location.pathname = pathname;
    return (_jsxs(Switch, Object.assign({ location: location }, { children: [routes.map((route) => {
                var _a;
                const newPath = `${path}${route.path}`;
                const WrapperComponent = (_a = route.wrapperComponent) !== null && _a !== void 0 ? _a : Fragment;
                return (_jsx(Route, Object.assign({ path: newPath }, { children: _jsxs(WrapperComponent, { children: [_jsx(ComponentRoute, { route: route, newPath: newPath }, void 0),
                            _jsx(RoutingComponents, { routes: route.routes, parentRoute: route, path: newPath }, void 0)] }, void 0) }), path));
            }),
            _jsx(OptionalRedirect, { route: parentRoute, routes: routes, path: path }, void 0)] }), void 0));
};
//# sourceMappingURL=RoutingComponents.js.map